import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

import { ResourcesService } from '../resources.service';

@Component({
    selector: 'app-pesajes',
    templateUrl: './pesajes.component.html',
    styleUrls: ['./pesajes.component.css']
})
export class PesajesComponent implements OnInit {

    semanas: any = [];
    user: any = {};
    idcorral: string;
    title: string = '';
    galpon: string = '';
    corral: string = '';
    lote: string = '';
    current_corral: number = 0;
    permitir: boolean = false;
    permitirInternet : boolean = true;
    no_cargo: boolean = true;
    internet : any = {}

    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        private router: Router,
        public resource: ResourcesService,
        private _location: Location
    ) {
        let user = localStorage.getItem('user')
        this.user = JSON.parse(user);
        if (user == undefined) {
            this.router.navigate(['/']);
            return
        } else {
            this.route.paramMap.subscribe(params => {
                this.idcorral = params.get('idcorral');
                this.current_corral = Number(params.get('idlote'));
                if (this.user.TipoPesaje == 2) {
                    setInterval(()=> {
                        this.internet = this.resource.internet;
                        if(this.internet.wifi != 'wifi'){
                            this.permitirInternet = false;
                        }else{
                            this.permitirInternet = true;
                        }
                    }, 1000);
                    this.getNameNacimiento(this.idcorral)
                    var url_semanas = resource.route + '/semanas/nacimientos/'+this.current_corral+"/"+ this.idcorral;
                    this.http.get(resource.routePlanta+'/nacimiento/nacimientodet-nac/'+this.idcorral).subscribe(
                        (data: any) => {
                            this.title = data.cabecera[0].CodCarga
                            for (let i = 0; i < data.detalle.length; i++) {
                                const d = data.detalle[i];
                                if(d.idLote == this.current_corral){
                                    this.lote = d.CodigoLote
                                    this.getNameGalpon(d.idGalpon)
                                }
                            }
                        }
                    );
                    this.http.get(url_semanas).subscribe(
                        (data: any) => {
                            this.no_cargo = false;
                            if (data.length > 0) {
                                for (let i = 0; i < data.length; i++) {
                                    data[i]['cloud'] = 'cloud'
                                    data[i]['idsemana'] = data[i]['id']
                                }
                            }
                            this.semanas = data;
                            if(this.semanas.length == 0){
                                this.permitir = true;
                            }
                        },
                        error => {
                            this.no_cargo = false;
                            var nacimientos = localStorage.getItem('nacimientos')
                            nacimientos = JSON.parse(nacimientos)

                            var semanas = localStorage.getItem('semanas')
                            semanas = JSON.parse(semanas)
                            console.log('semanas offline', semanas)
                            for (let i = 0; i < semanas.length; i++) {
                                if (semanas[i]['idcorral'] == this.idcorral && semanas[i]['idlote'] == this.current_corral) {
                                    if (semanas[i]['online'] == 1) {
                                        semanas[i]['cloud'] = 'cloud'
                                    } else {
                                        semanas[i]['cloud'] = 'exclamation-triangle'
                                    }
                                    semanas[i]['id'] = semanas[i]['idsemana']
                                    this.semanas.push(semanas[i])
                                }
                            }
                        }
                    );
                } else {
                    this.permitir = true;
                    var url_semanas = resource.route + '/semanas/' + this.idcorral;
                    if (this.idcorral.includes('9999')) {
                        this.permitir = false;
                    }
                    this.getNameCorral(this.idcorral)

                    // TRAER ID DEL CORRAL DE DONDE VIENE
                    var corrales = localStorage.getItem('corrales')
                    corrales = JSON.parse(corrales)
                    console.log('XXXX corrales online', corrales)
                    for (let i = 0; i < corrales.length; i++) {
                        if (corrales[i]['id'] == this.idcorral) {
                            this.current_corral = corrales[i]['idlote']
                        }
                    }
                    // TRAER TODOS LOS CORRALES
                    if (this.idcorral == null) {
                        this.router.navigate(['/lotes']);
                        return;
                    }

                    this.http.get(resource.route + '/corrales/name/' + this.idcorral).subscribe(
                        (data: any) => {
                            this.title = data[0]['corral']
                        }
                    );
                    this.http.get(url_semanas).subscribe(
                        (data: any) => {
                            this.no_cargo = false;
                            console.log('semanas', data)
                            if (data.length > 0) {
                                for (let i = 0; i < data.length; i++) {
                                    data[i]['cloud'] = 'cloud'
                                    data[i]['idsemana'] = data[i]['id']
                                }
                                this.getNameCorral(data[0]['idcorral'])
                                this.semanas = data;
                                resource.updateLocalStorageFromOnline()
                            }
                        },
                        error => {
                            this.no_cargo = false;
                            var corrales = localStorage.getItem('corrales')
                            corrales = JSON.parse(corrales)
                            for (let i = 0; i < corrales.length; i++) {
                                if (corrales[i]['id'] == this.idcorral) {
                                    if (this.title == '') {
                                        this.title = corrales[i]['corral']
                                    }
                                }
                            }

                            var semanas = localStorage.getItem('semanas')
                            semanas = JSON.parse(semanas)
                            console.log('semanas offline', semanas)
                            for (let i = 0; i < semanas.length; i++) {
                                if (semanas[i]['idcorral'] == this.idcorral) {
                                    if (semanas[i]['online'] == 1) {
                                        semanas[i]['cloud'] = 'cloud'
                                    } else {
                                        semanas[i]['cloud'] = 'exclamation-triangle'
                                    }
                                    semanas[i]['id'] = semanas[i]['idsemana']
                                    this.semanas.push(semanas[i])
                                }
                            }
                        }
                    );
                    // Cargar data de storage si falla el online
                    setTimeout(() => {
                        if (this.no_cargo) {
                            alert('Hubo una pérdida de conexión. Se recargará la página.')
                            window.location.reload();
                        }
                    }, 2000);
                }
            });
        }
    }

    getNameGalpon(idgalpon) {
        var galpones = localStorage.getItem('galpones')
        galpones = JSON.parse(galpones);
        console.log('galpones', galpones)
        for (let i = 0; i < galpones.length; i++) {
            if (galpones[i]['idGalpon'] == idgalpon) {
                this.galpon = 'Galpón ' + galpones[i]['Galpon']
            }
        }
    }

    getNameCorral(idcorral) {
        var corrales = localStorage.getItem('corrales')
        corrales = JSON.parse(corrales);
        console.log(idcorral, corrales)
        for (let i = 0; i < corrales.length; i++) {
            if (corrales[i]['id'] == idcorral) {
                this.title = corrales[i]['corral']
                this.lote = corrales[i]['lote']
                this.getNameGalpon(corrales[i]['idGalpon'])
            }
        }
    }

    getNameNacimiento(idcorral) {
        var nacimientos = JSON.parse(localStorage.getItem('nacimientos'))
        for (let i = 0; i < nacimientos.length; i++) {
            const n = nacimientos[i];
            if (n.idNacimiento == idcorral) {
                this.title = n.CodCarga
                for (let j = 0; j < n.detalle.length; j++) {
                    const d = n.detalle[j];
                    if(d.idLote == this.current_corral){
                        this.lote = d.CodigoLote
                    }
                }
            }
        }

        var lotes = JSON.parse(localStorage.getItem('lotes'))
        for (let i = 0; i < lotes.length; i++) {
            const l = lotes[i];
            if(this.current_corral == l.idLote){
                this.getNameGalpon(l['idGalpon'])
            }
        }
    }

    ngOnInit(): void {
    }

    agregarPeso(idcorral) {
        this.router.navigate(['/agregar-peso/' + this.current_corral + "/" + idcorral]);
    }

    goToSemana(idsemana) {
        this.router.navigate(['/semana/' + this.current_corral + "/" + this.idcorral + "/" + idsemana]);
    }

    regresar() {
        this.router.navigate(['/corrales/' + this.current_corral]);
    }

}
